import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/ChemicalEngineering.css';
import chemEngImage from '../assets/teamSensorsImg.jpg'; // Adjust path if needed

const ChemicalEngineering = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  return (
    <div className="ChemicalEngineeringPage">
      <Header />

      <section className="hero-banner13">
        <div className="hero-content">
          <h1>CHEMICAL ENGINEERING</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Chemical Engineering</span>
          </div>
        </div>
      </section>

      <section className="chem-main">
        <div className="chem-left">
          <div className="side-menu">
            <div className="menu-title">Sensors</div>
            <ul>
              <li><a href='/PositionSensor'>Position sensors</a></li>
              <li><a href='/ProcessFluidSensors'>Process sensors / Fluid sensors</a></li>
              <li><a href='/AiImageRecognition'>AI Image Recognition</a></li>
              <li><a href='/CodeReaderNew'>Code Reader</a></li>
              <li><a href='/TestBox'>Test Box</a></li>
              <li><a href='/ChemicalEngineering'>Chemical Engineering</a></li>
            </ul>
            <div className="button-box">
              <button>📄 Download Brochures</button>
              <button>📎 Company Presentation</button>
            </div>
          </div>
        </div>

        <div className="chem-right">
          <img src={chemEngImage} alt="Chemical Engineering" />
          <div className="text-content">
            <h2>Chemical Engineering</h2>
            <p>
              Mechanical engineering is a diverse subject that derives its breadth from the need to design and manufacture
              everything from small individual parts and devices (e.g., microscale sensors and inkjet printer nozzles) to
              large systems (e.g., spacecraft and machine tools).
            </p>
            <p>
              The mechanical engineer needs to acquire particular skills and knowledge to understand forces, environments,
              and how things move — making mechanical strategy a foundational concept in engineering.
            </p>
          </div>

          <h3 className="subheading">Mechanical Strategy</h3>
          <p className="strategy-text">
            The most likely cause of profit decline was a period of mechanical-strategy drawdown.
            Time and time again we see this pattern. Don't give up—refocus your strategy, or try
            a different one altogether. Avoid emotional decisions during this stage.
          </p>

          <h3 className="subheading">Frontiers of Research</h3>
          <p className="research-intro">
            Mechanical engineering applies to nearly everything we build. Hence, its research
            domain includes some of the broadest and most diverse engineering disciplines.
          </p>

          <div className="accordion">
            {[
              'Micro electro-mechanical systems',
              'Friction stir welding',
              'Composites'
            ].map((item, index) => (
              <div className={`accordion-item ${activeAccordion === index ? 'active' : ''}`} key={index}>
                <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                  {item}
                  <span className="toggle-icon">{activeAccordion === index ? '−' : '+'}</span>
                </div>
                {activeAccordion === index && (
                  <div className="accordion-content">
                    <p>
                      Micron-scale mechanical components such as springs, gears, fluidic and heat
                      transfer devices are fabricated from materials like silicon, glass, and polymers like SU8.
                      MEMS examples include accelerometers in cars, gyroscopes in phones, and biomedical microfluidic devices.
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ChemicalEngineering;
